import { Component } from '@angular/core';
import { StorageService } from '../../../../services/StorageService';
import { VenueService } from '../../../../services/VenueService';
import { Router } from '@angular/router';
import { Apiservice } from '../../../../services/ApiService';

@Component({
  selector: 'app-gates',
  templateUrl: './gates.component.html',
  styleUrl: './gates.component.scss'
})

export class GatesComponent {

  Selectedvenue: string = '';
  venuelist: any[] = [];
  venueValue: string = '';
  gatesArray: any = [];
  deleteDisplay: boolean = false;
  gatesTable: boolean = true;
  editDisplay: boolean = false;
  addDisplay: boolean = false;
  gatesTableAdd: boolean = false;
  loading: boolean = false;

  constructor(private storage: StorageService,private router: Router, public venue: VenueService, private apiservice: Apiservice) {
  }

  getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;
    });
  }

  onVenueChange(){
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value: '';
    this.getGates(this.Selectedvenue);
  }

  selectDeleteGateClick(event: any, data: any){ 
    this.router.navigate(['tools/gates/delete'], { state: { gate: data, gatesArray: this.gatesArray, Selectedvenue: this.Selectedvenue } });
  }

  selectEditGateClick(event: any, data: any){ 
    this.router.navigate(['tools/gates/edit'], { state: { gate: data, gatesArray: this.gatesArray, Selectedvenue: this.Selectedvenue } });
  }


  addGate(){
    this.router.navigate(['tools/gates/add'], { state: { Selectedvenue: this.Selectedvenue, gates:this.gatesArray  } });
  }

  getGates(event: any) {
    this.apiservice.getGates(this.Selectedvenue).subscribe((result: any) => {
      this.gatesArray = Object.entries(result.gates).map(([key, value]) => ({
        key,
        value,
        
      }));
    });
  }


  async ngOnInit() {
    this.getVenueList();
    const savedVenue = this.storage.getVenue();
    if (savedVenue) {
      this.Selectedvenue = savedVenue;
    }
    this.getGates(this.Selectedvenue);
  }
  
}
